module.exports = __webpack_public_path__ + "static/media/bird.7f852108.wav";